import { render, staticRenderFns } from "./QuestEventChronicle.vue?vue&type=template&id=cff11828&scoped=true"
import script from "./QuestEventChronicle.vue?vue&type=script&lang=js"
export * from "./QuestEventChronicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff11828",
  null
  
)

export default component.exports